import { entries, groupBy, sortBy } from 'lodash';
import type { GroupedOptionsType } from '../../common-ui/form-fields/Dropdown';
import type { Route } from '../graphql/fragments/gql/Route';
import type { DropdownOption } from './optionTransformers';

export const getRoutesGroupedBySeaAreas = (allRoutes: Route[]): Array<[string, Route[]]> =>
  entries(
    groupBy(sortBy(allRoutes, ['routePairCode', 'seaAreaDescription']), 'seaAreaDescription'),
  );

export const getGroupedOptionsBySeaArea = (
  allRoutes: Route[],
): GroupedOptionsType<DropdownOption<Route>> =>
  getRoutesGroupedBySeaAreas(allRoutes).map(([seaAreaKey, routes]) => ({
    label: seaAreaKey,
    value: '',
    options: routes.map(
      (route: Route): DropdownOption<Route> => ({
        data: route,
        label: route.longDescription,
        value: getRouteValue(route),
      }),
    ),
  }));

export const getRouteValue = (route: Route): string => route.code;
